import { FC } from 'react';

import { Icon } from './Icon';
import { SvgIcon } from './SvgIcon.type';

export const IconHide: FC<SvgIcon> = (props) => (
  <Icon {...props} viewBox="0 0 24 24" name="hide">
    <path d="M20.424 4.424a.6.6 0 0 0-.848-.848l-16 16a.6.6 0 0 0 .848.848l16-16ZM12 5.4c.991 0 1.936.137 2.824.382l-.997.997A9.375 9.375 0 0 0 12 6.6c-3.814 0-6.889 2.3-8.5 4.85a1.026 1.026 0 0 0 0 1.1 10.776 10.776 0 0 0 2.122 2.434l-.85.85a11.986 11.986 0 0 1-2.287-2.643 2.226 2.226 0 0 1 0-2.382C4.265 7.992 7.687 5.4 12 5.4Z" />
    <path d="M12 8c.192 0 .381.014.566.04l-1.242 1.242a2.805 2.805 0 0 0-2.042 2.042L8.04 12.566A4 4 0 0 1 12 8ZM15.96 11.434l-1.242 1.243a2.805 2.805 0 0 1-2.041 2.04l-1.243 1.243a4 4 0 0 0 4.526-4.526Z" />
    <path d="M12 17.4a9.38 9.38 0 0 1-1.827-.18l-.997.998c.888.245 1.833.382 2.824.382 4.17 0 7.706-2.591 9.51-5.408a2.217 2.217 0 0 0 .005-2.383 11.981 11.981 0 0 0-2.287-2.643l-.85.85a10.773 10.773 0 0 1 2.123 2.435c.213.336.212.761-.001 1.094-1.634 2.551-4.824 4.855-8.5 4.855Z" />
  </Icon>
);
